import { LinearProgress } from '@mui/material';
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton } from '@mui/x-data-grid';
import React, { useState } from 'react';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';
import { StyledDataGrid } from '../../../components/StyledComponents';
import CustomGridToolbarQuickFilter from '../CustomGridToolbarQuickFilter';
import CustomPagination from '../CustomPagination';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';

const columnData = [
   { field: 'overtimeName', headerName: 'Name', minWidth: 150, flex: 1, hideable: true },
   { field: 'overtimeId', headerName: 'ID', minWidth: 150, flex: 1, hideable: true },
   { field: 'shiftName', headerName: 'Shift name', minWidth: 150, flex: 1, hideable: true },
   { field: 'firstCheckedIn', headerName: 'First Checked-in', minWidth: 150, flex: 1, hideable: true },
   { field: 'firstCheckedOut', headerName: 'First Checked-out', minWidth: 150, flex: 1, hideable: true },
   { field: 'maxOTStatus', headerName: 'Max OT status', minWidth: 150, flex: 1, hideable: true },
   { field: 'overtimeWorkHours', headerName: 'Overtime work hours', minWidth: 150, flex: 1, hideable: true },
   { field: 'maxOT', headerName: 'Max OT', minWidth: 150, flex: 1, hideable: true },
];

const OvertimeTab = () => {
   const [columnVisibilityModel, setColumnVisibilityModel] = useState({
      overtimeName: true,
      overtimeId: true,
      shiftName: true,
      firstCheckedIn: true,
      firstCheckedOut: true,
      maxOTStatus: true,
      overtimeWorkHours: true,
      maxOT: true,
   });

   const rowData = [];

   const CustomToolbar = () => {
      return (
         <div>
            <GridToolbarContainer className='flex justify-between items-center'>
               <div className='flex gap-3'>
                  <GridToolbarColumnsButton />
                  <GridToolbarFilterButton />
                  <GridToolbarDensitySelector />
               </div>
               <div className='mt-2'>
                  <CustomGridToolbarQuickFilter />
               </div>
            </GridToolbarContainer>
         </div>
      );
   };

   return (
      <div className='h-[800px]'>
         <StyledDataGrid
            rows={rowData}
            columns={columnData}
            slots={{
               toolbar: CustomToolbar,
               pagination: CustomPagination,
               loadingOverlay: LinearProgress,
               noRowsOverlay: NoRowOverlay,
               columnsPanel: CustomColumnsPanel,
            }}
            slotProps={{
               toolbar: {
                  showQuickFilter: true,
               },
               noRowsOverlay: {
                  title: 'No events',
               },
            }}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
            initialState={{
               filter: {
                  filterModel: {
                     items: [],
                     quickFilterValues: [''],
                  },
               },
               pagination: {
                  paginationModel: { pageSize: 10 },
               },
            }}
            pageSizeOptions={[5, 10, 25]}
         />
      </div>
   );
};

export default OvertimeTab;
